import { render, staticRenderFns } from "./oncallManagement.vue?vue&type=template&id=2913d2d0&scoped=true&"
import script from "./oncallManagement.vue?vue&type=script&lang=ts&"
export * from "./oncallManagement.vue?vue&type=script&lang=ts&"
import style0 from "./oncallManagement.vue?vue&type=style&index=0&id=2913d2d0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913d2d0",
  null
  
)

export default component.exports